import { ReactComponent as Dash } from 'Assets/placeholders/dash.svg';

type Props = {
  content?: string;
  separator?: string;
  placeholder?: boolean;
};

const ContentWithBreaks = ({
  content,
  separator,
  placeholder,
}: Props): JSX.Element => {
  if (!content) {
    return placeholder ? <Dash /> : <></>;
  }

  const lines = content.split(separator || '<br />');

  return (
    <div>
      {lines.map((line, index) =>
        line === '' ? (
          <br key={`br-${index}`} />
        ) : (
          <div
            key={index}
            dangerouslySetInnerHTML={{ __html: line }}
            style={{ overflowWrap: 'anywhere' }}
          />
        ),
      )}
    </div>
  );
};

export default ContentWithBreaks;
